import { Collection } from 'firestorter';

import BaseDocument from '../../Model/BaseDocument';
import Collections from '../../utils/collections';

class ISAvailability extends BaseDocument {
  constructor(id, opts) {
    super(`${Collections.IS_AVAILABILITY}/${id}`, opts);
  }

  static async getAvailabilityForADateRange(startDate, endDate) {
    const availabilityCollection = new Collection(Collections.IS_AVAILABILITY_FOR_CALLS, {
      query: (ref) => ref
        .where('from', '>=', startDate)
        .where('from', '<', endDate),
    });
    await availabilityCollection.fetch();
    return availabilityCollection;
  }
}

export default ISAvailability;
